/**
 * Query keys for SMSWiser campaign workspace
 * For Media Devoted | Created By Ciro Autiero
 */

const ROOT = ['smswiser-campaign-workspace'] as const;

function key(...segments: (string | number | Record<string, unknown>)[]) {
  return [...ROOT, ...segments] as const;
}

function statsKey(name: string) {
  return (countryKey: string, wiserIds: number[], params: Record<string, unknown>) =>
    key(name, countryKey, wiserIds.join(','), params);
}

function statsPrefix(name: string) {
  return (countryKey: string) => key(name, countryKey);
}

function trafficStatsKey(name: string) {
  return (
    countryKey: string,
    trafficCampaignId: string | undefined,
    wiserIds: number[],
    params: Record<string, unknown>,
  ) => key(name, countryKey, trafficCampaignId ?? wiserIds.join(','), params);
}

export const smswiserCampaignWorkspaceKeys = {
  all: ROOT,
  detail: (countryKey: string, wiserId: number) => key('detail', countryKey, wiserId),
  dropsWithStats: statsKey('dropsWithStats'),
  dropsWithStatsPrefix: statsPrefix('dropsWithStats'),
  listsWithStats: statsKey('listsWithStats'),
  listsWithStatsPrefix: statsPrefix('listsWithStats'),
  textsWithStats: statsKey('textsWithStats'),
  textsWithStatsPrefix: statsPrefix('textsWithStats'),
  gatewaysWithStats: statsKey('gatewaysWithStats'),
  gatewaysWithStatsPrefix: statsPrefix('gatewaysWithStats'),
  sourcesWithStats: statsKey('sourcesWithStats'),
  sourcesWithStatsPrefix: statsPrefix('sourcesWithStats'),
  phonesWithStats: statsKey('phonesWithStats'),
  phonesWithStatsPrefix: statsPrefix('phonesWithStats'),
  pathsWithStats: trafficStatsKey('pathsWithStats'),
  landersWithStats: trafficStatsKey('landersWithStats'),
  offersWithStats: trafficStatsKey('offersWithStats'),
  preparedDrops: (countryKey: string, wiserId: number, workDate?: string) =>
    key('preparedDrops', countryKey, wiserId, workDate ?? 'all'),
  preparedDropsPrefix: (countryKey: string, wiserId: number) => key('preparedDrops', countryKey, wiserId),
  preparedDropsByCountry: (countryKey: string, workDate?: string) =>
    key('preparedDropsByCountry', countryKey, workDate ?? 'all'),
  preparedDropsByCountryPrefix: (countryKey: string) => key('preparedDropsByCountry', countryKey),
  presets: (countryKey: string) => key('presets', countryKey),
  presetFolders: (countryKey: string) => key('presetFolders', countryKey),
  creative: (countryKey: string, wiserId: number) => key('creative', countryKey, wiserId),
  countryCreative: (countryKey: string) => key('countryCreative', countryKey),
  countryCreativeForStats: (countryKey: string) => key('countryCreativeForStats', countryKey),
};

/** @deprecated Use smswiserCampaignWorkspaceKeys */
export const keys = smswiserCampaignWorkspaceKeys;
